module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Paula Graves\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Born in the American South, Paula Graves draws from her experiences with the culture and geography of the region, especially the Appalachian Mountains, to add authentic flavor and unique characters to her tales of romance and mystery."), _c('Br', [_c('Br', [_c('a', {
    attrs: {
      "href": "http://www.paulagraves.com"
    }
  }, [_vm._v("www.paulagraves.com")])])], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DNMU9q/tc-custom/9781488012747.jpg?1740633431879",
      "alt": "This image is the cover for the book Operation Nanny, Campbell Cove Academy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Operation Nanny, Campbell Cove Academy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_c('b', [_vm._v("WANTED: NANNY ")])]), _c('br'), _c('br'), _c('i', [_c('b', [_vm._v("MUST BE GOOD WITH WET WIPES AND GUNS.")])]), _c('i', [_c('b')]), _c('br'), _c('br'), _vm._v("Lacey Miles becomes the unexpected sole guardian of her young niece. Knee-deep into an investigation of a sleeper cell, Lacey finds that motherhood is a lot more perilous than she expected, so she hires a nanny with an impeccable résuméwho's a far cry from Mary Poppins. "), _c('br'), _c('br'), _vm._v("Beneath his friendly demeanor, Jim Mercer is a former Marine turned undercover agent, tasked with ferreting out the terrorists targeting Lacey and her loved ones. Jim may be the ultimate caretaker, but the closer Lacey comes to blowing her case open, the more Jim's true identity is revealed. And the deeper he falls for this vulnerable little family. "), _c('br'), _c('br'), _c('b', [_vm._v("Campbell Cove Academy")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0